<template>
  <card>
    <template v-slot>
      <div class="flex item-start">
        <div class="flex-shrink-0"><v-shield-check-outline></v-shield-check-outline></div>
        <div class="flex-1">
          <div class="text-2xl font-semibold leading-6 flex-1 mx-2">
            {{ twoFactorConfig.enable2FaPopupTitle }}
          </div>
        </div>
      </div>
      <div class="grid my-2">
        <div class="w-1/3">
          <p>{{ twoFactorConfig.enable2FaPopupDescription }}</p>
          <v-input-group-simple-2
            id="authorizationCode"
            v-model:value="authorizationCode"
            maxlength="6"
            placeholder="Uw verificatiecode"
            data-vv-as="Authorizatie code"
            :overwrite-value="authorizationCode"
            :rules="{
              required: false
            }"
            @input="saveInput($event)"
          />
          <small v-if="authenticationNotEnabled && !showResendText" class="text-red-700 block mx-2 my-4">{{
            twoFactorConfig.invalid2FaCode
          }}</small>
          <small v-if="showResendText && !authenticationNotEnabled" class="text-red-700 block mx-2 my-4">
            Er is een nieuwe code verstuurd naar uw email.
          </small>
          <v-button class="resend-button ml-1 py-2.5" transparent hollow @click="resendVerificationCode()">
            {{ twoFactorConfig.resend2FaCodeButtonLabel }}
          </v-button>
        </div>
      </div>
      <div class="row justify-end">
        <v-button md hollow transparent @click="closeEditAuthentication"> Annuleren </v-button>
        <v-button :disabled="authorizationCode.length <= 5" md primary @click="enable2FA()"> Bevestigen </v-button>
      </div>
    </template>
  </card>
</template>

<script>
import { tap } from 'rxjs/operators';
import VShieldCheckOutline from 'icons/ShieldCheckOutline';
import {
  currentUserIdentity$,
  twoFactorAuthenticationSettingsConfiguration$,
  enable2FactorAuthentication,
  twoFactorAuthenticationNotEnabledEvent$,
  twoFactorAuthenticationEnabledEvent$
} from '@/services';
import { ref, onMounted } from 'vue';

export default {
  name: 'PrescriberTwoFactorEnableAuthModal',
  components: { VShieldCheckOutline },
  setup() {
    const currentUserIdentity = ref(null);
    const twoFactorConfig = ref(null);
    const twoFactorAuthenticationEnabledEvent = ref(null);
    const authorizationCode = ref('');
    const authenticationNotEnabled = ref(false);
    const showResendText = ref(false);

    currentUserIdentity$.subscribe((value) => (currentUserIdentity.value = value));
    twoFactorAuthenticationSettingsConfiguration$.subscribe((value) => (twoFactorConfig.value = value));
    twoFactorAuthenticationEnabledEvent$.subscribe((value) => (twoFactorAuthenticationEnabledEvent.value = value));

    twoFactorAuthenticationNotEnabledEvent$.pipe(
      tap((e) => {
        authorizationCode.value = '';
        authenticationNotEnabled.value = true;
        showResendText.value = false;
      })
    );

    const saveInput = (event) => {
      authorizationCode.value = event.target.value;
    };

    onMounted(() => enable2FactorAuthentication());

    return {
      currentUserIdentity,
      twoFactorConfig,
      twoFactorAuthenticationEnabledEvent,
      authorizationCode,
      authenticationNotEnabled,
      showResendText,
      saveInput
    };
  },
  methods: {
    closeEditAuthentication() {
      this.$emit('closeEditAuthentication', false);
    },
    resendVerificationCode() {
      enable2FactorAuthentication();
      this.showResendText = true;
      this.authenticationNotEnabled = false;
    },
    async enable2FA() {
      await enable2FactorAuthentication(this.authorizationCode).then((response) => {
        if (response?.data?.length > 1) {
          this.closeEditAuthentication();
          this.$emit('success');
        } else {
          this.$emit('error');
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.resend-button {
  color: $black;
  text-decoration: underline;
  font-weight: 400;
}
</style>
